import { useQuery } from '@tanstack/react-query';

import { getAttractionPerformance } from '~/services/AttractionsService';

import type { AttractionPerformanceParams } from '~/types/attractionTypes';

import { attractionQueryKeys } from './attractionQueryKeys';

interface UseGetAttractionPerformanceOptions {
  enabled?: boolean;
}

export function useGetAttractionPerformance(
  params: AttractionPerformanceParams = {},
  options: UseGetAttractionPerformanceOptions = {},
) {
  const { enabled = true } = options;
  return useQuery({
    queryKey: attractionQueryKeys.performance(params as Record<string, unknown>),
    queryFn: async ({ signal }) => {
      return await getAttractionPerformance(params, { signal });
    },
    enabled,
    retry: false,
  });
}
